<template>
  <article-template class="mb-20" :document="article">
    <template #sidebar>
      <article-sidebar
        :article="article"
        :category-id="categoryEntry?.sys?.id"
        :slider-type="categoryParam === 'laga-vego' ? 'recipe' : 'category'"
      >
      </article-sidebar>
    </template>
  </article-template>
</template>

<script lang="ts" setup>
import { fetchArticleWithErrorHandling } from '@/utils/contentfulHelpers'

const route = useRoute()
const categoryParam = route.params.category as string
const slug = route.params.slug as string

if (!categoryParam || !slug) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Category or slug not found',
  })
}

// Get Contentful client
const { getCategoryBySlug } = useContentful()

const categoryEntry = await useStatic(
  `category:${categoryParam}`,
  () => getCategoryBySlug(categoryParam),
  { allowNull: true },
)

if (!categoryEntry) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Category not found',
  })
}

// Fetch article data with error handling
const article = await fetchArticleWithErrorHandling(slug, `article:${categoryParam}:${slug}`)
</script>
